export enum EShape {
  RECTANGLE = "0",
  ELLIPSIS = "1",
}
